import { render, staticRenderFns } from "./ScannerInKiev.vue?vue&type=template&id=53872df2&scoped=true"
import script from "./ScannerInKiev.vue?vue&type=script&lang=js"
export * from "./ScannerInKiev.vue?vue&type=script&lang=js"
import style0 from "./ScannerInKiev.vue?vue&type=style&index=0&id=53872df2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53872df2",
  null
  
)

export default component.exports